import React, { useState } from "react";
import PropTypes from "prop-types";
import { useDispatch } from "react-redux";
import { Link, useLocation } from "react-router-dom";
import { useFormik } from "formik";
import * as Yup from "yup";
import { styled } from "@mui/material/styles";
import { useTheme } from "@mui/material/styles";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import TextField from "@mui/material/TextField";
import FormControl from "@mui/material/FormControl";
import InputLabel from "@mui/material/InputLabel";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import FormHelperText from "@mui/material/FormHelperText";
import Button from "@mui/material/Button";
import IconButton from "@mui/material/IconButton";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCellMui from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TablePagination from "@mui/material/TablePagination";
import TableRow from "@mui/material/TableRow";
import TableFooter from "@mui/material/TableFooter";
import TableSortLabel from "@mui/material/TableSortLabel";
import Toolbar from "@mui/material/Toolbar";
import Checkbox from "@mui/material/Checkbox";
import { visuallyHidden } from "@mui/utils";
import Divider from "@mui/material/Divider";
import ToggleButtonGroup from "@mui/material/ToggleButtonGroup";
import Paper from "@mui/material/Paper";
import CircularProgress from '@mui/material/CircularProgress';

import SearchIcon from "@mui/icons-material/Search";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import FilterAltOutlinedIcon from "@mui/icons-material/FilterAltOutlined";
import CachedIcon from "@mui/icons-material/Cached";
import AppRegistrationOutlinedIcon from '@mui/icons-material/AppRegistrationOutlined';
import PrintOutlinedIcon from "@mui/icons-material/PrintOutlined";
import FileDownloadOutlinedIcon from "@mui/icons-material/FileDownloadOutlined";
import FirstPageIcon from "@mui/icons-material/FirstPage";
import KeyboardArrowLeft from "@mui/icons-material/KeyboardArrowLeft";
import KeyboardArrowRight from "@mui/icons-material/KeyboardArrowRight";
import LastPageIcon from "@mui/icons-material/LastPage";
import AddIcon from "@mui/icons-material/Add";

import MinimalPage from "../../layout/MinimalPage";
import api from "../../service/api";
import { setError } from "../../reducers/appSlice";
//import Recepcionar from "../../commons/Recepcionar";
import Estados from "../../commons/Estados";
import Archivar from "../../commons/Archivar";
import BuscadorTema from "../../commons/BuscadorTema";
import BuscadorOrganismo from "../../commons/BuscadorOrganismo";
import VisorPdf from "../../components/Visorpdf";
import Modal from "../../components/Modal";
import Accion from "../../components/Accion";
import Iniciadores from "../altaTramite/Iniciadores";
import GeneradorPDF from "./GeneradorPDF";

const TableCellHead = styled(TableCellMui)(({ theme }) => ({
  color: "#3c4b64",
  padding: theme.spacing(1, 1, 1, 1),
}));

const TableCell = styled(TableCellMui)(({ theme }) => ({
  padding: theme.spacing(1, 1, 1, 1),
}));

const StyledToggleButtonGroup = styled(ToggleButtonGroup)(({ theme }) => ({
  "& .MuiToggleButtonGroup-grouped": {
    margin: theme.spacing(0.5),
    border: 0,
    "&.Mui-disabled": {
      border: 0,
    },
    "&:not(:first-of-type)": {
      borderRadius: theme.shape.borderRadius,
    },
    "&:first-of-type": {
      borderRadius: theme.shape.borderRadius,
    },
  },
}));

function descendingComparator(a, b, orderBy) {
  if (b[orderBy] < a[orderBy]) {
    return -1;
  }
  if (b[orderBy] > a[orderBy]) {
    return 1;
  }
  return 0;
}

function getComparator(order, orderBy) {
  return order === "desc"
    ? (a, b) => descendingComparator(a, b, orderBy)
    : (a, b) => -descendingComparator(a, b, orderBy);
}

// This method is created for cross-browser compatibility, if you don't
// need to support IE11, you can use Array.prototype.sort() directly
function stableSort(array, comparator) {
  const stabilizedThis = array.map((el, index) => [el, index]);
  stabilizedThis.sort((a, b) => {
    const order = comparator(a[0], b[0]);
    if (order !== 0) {
      return order;
    }
    return a[1] - b[1];
  });
  return stabilizedThis.map((el) => el[0]);
}

const headCells = [
  {
    id: "expediente",
    numeric: true,
    disablePadding: true,
    label: "Expediente",
    width: 150,
    align: "center",
  },
  {
    id: "tramiteInterno",
    numeric: true,
    disablePadding: false,
    label: "Trámite Interno",
    width: 150,
    align: "center",
  },
  {
    id: "descOrgGenCompleta",
    numeric: false,
    disablePadding: false,
    label: "Tramitado en",
    width: 400,
    align: "left",
  },
  {
    id: "asunto",
    numeric: false,
    disablePadding: false,
    label: "Asunto",
    width: 400,
    align: "left",
  },
  {
    id: "soporte",
    numeric: false,
    disablePadding: false,
    label: "Soporte",
    width: 50,
    align: "center",
  },
];

function EnhancedTableHead(props) {
  const {
    order,
    orderBy,
    onRequestSort,
  } = props;
  const createSortHandler = (property) => (event) => {
    onRequestSort(event, property);
  };

  return (
    <TableHead>
      <TableRow>
        <TableCell padding="checkbox" width={50}>
          {" "}
        </TableCell>
        {headCells.map((headCell) => (
          <TableCellHead
            key={headCell.id}
            align={headCell.align}
            padding="normal"
            sortDirection={orderBy === headCell.id ? order : false}
            width={headCell.width}
          >
            <TableSortLabel
              active={orderBy === headCell.id}
              direction={orderBy === headCell.id ? order : "asc"}
              onClick={createSortHandler(headCell.id)}
            >
              <b>{headCell.label}</b>
              {orderBy === headCell.id ? (
                <Box component="span" sx={visuallyHidden}>
                  {order === "desc"
                    ? "ordenado descendente"
                    : "ordenado ascendente"}
                </Box>
              ) : null}
            </TableSortLabel>
          </TableCellHead>
        ))}
        <TableCellHead width={200} align="center">
          <b>Acciones</b>
        </TableCellHead>
      </TableRow>
    </TableHead>
  );
}

EnhancedTableHead.propTypes = {
  numSelected: PropTypes.number.isRequired,
  onRequestSort: PropTypes.func.isRequired,
  onSelectAllClick: PropTypes.func.isRequired,
  order: PropTypes.oneOf(["asc", "desc"]).isRequired,
  orderBy: PropTypes.string.isRequired,
  rowCount: PropTypes.number.isRequired,
};

const TablePaginationActions = (props) => {
  const theme = useTheme();
  const { count, page, rowsPerPage, onPageChange } = props;

  const handleFirstPageButtonClick = (event) => {
    onPageChange(event, 0);
  };

  const handleBackButtonClick = (event) => {
    onPageChange(event, page - 1);
  };

  const handleNextButtonClick = (event) => {
    onPageChange(event, page + 1);
  };

  const handleLastPageButtonClick = (event) => {
    onPageChange(event, Math.max(0, Math.ceil(count / rowsPerPage) - 1));
  };

  return (
    <Box sx={{ flexShrink: 0, ml: 2.5 }}>
      <IconButton
        onClick={handleFirstPageButtonClick}
        disabled={page === 0}
        aria-label="first page"
      >
        {theme.direction === "rtl" ? <LastPageIcon /> : <FirstPageIcon />}
      </IconButton>
      <IconButton
        onClick={handleBackButtonClick}
        disabled={page === 0}
        aria-label="previous page"
      >
        {theme.direction === "rtl" ? (
          <KeyboardArrowRight />
        ) : (
            <KeyboardArrowLeft />
          )}
      </IconButton>
      <IconButton
        onClick={handleNextButtonClick}
        disabled={page >= Math.ceil(count / rowsPerPage) - 1}
        aria-label="next page"
      >
        {theme.direction === "rtl" ? (
          <KeyboardArrowLeft />
        ) : (
            <KeyboardArrowRight />
          )}
      </IconButton>
      <IconButton
        onClick={handleLastPageButtonClick}
        disabled={page >= Math.ceil(count / rowsPerPage) - 1}
        aria-label="last page"
      >
        {theme.direction === "rtl" ? <FirstPageIcon /> : <LastPageIcon />}
      </IconButton>
    </Box>
  );
};

TablePaginationActions.propTypes = {
  count: PropTypes.number.isRequired,
  onPageChange: PropTypes.func.isRequired,
  page: PropTypes.number.isRequired,
  rowsPerPage: PropTypes.number.isRequired,
};

const validationSchema = Yup.object().shape({
  nroExpediente: Yup.number()
    .integer("Debe ingresar un número entero")
    .positive("Debe ingresar un número positivo")
    .typeError("Solo números"),
  nroTramite: Yup.number()
    .integer("Debe ingresar un número entero")
    .positive("Debe ingresar un número positivo")
    .typeError("Solo números"),
  digital: Yup.string(),
  archivado: Yup.string(),
  tipoTramite: Yup.string(),
  codigoTema: Yup.number(),
  tema: Yup.string(),
  asunto: Yup.string(),
  codigoOrganismoGenerador: Yup.number(),
  organismoGenerador: Yup.string(),
  // iniciadores: Yup.string(),
  fechaDesde: Yup.date().when(["nroExpediente", "nroTramite", "iniciadores"], {
    is: (nroExpediente, nroTramite, iniciadores) => !(nroExpediente) && !(nroTramite) && (iniciadores < 1),
    then: Yup.date()
      .typeError("Formato no válido")
      .required("Requerido")
      .min("01/01/1992", "Fecha no válida")
      .max(new Date(), "Fecha no válida"),
  }),
  fechaHasta: Yup.date().when(["nroExpediente", "nroTramite", "iniciadores"], {
    is: (nroExpediente, nroTramite, iniciadores) => !(nroExpediente) && !(nroTramite) && (iniciadores < 1),
    then: Yup.date()
      .typeError("Formato no válido")
      .required("Requerido")
      .max(new Date(), "Fecha no válida")
      .min(Yup.ref("fechaDesde"), "Rango fecha no válido"),
  }),
});

const EnhancedTableToolbar = (props) => {
  const { numSelected, selected, resetearTabla, submitting, expedientes } = props;
  const [alignment, setAlignment] = React.useState("left");

  const handleAlignment = (event, newAlignment) => {
    setAlignment(newAlignment);
  };

  return (
    <>
      <Grid container sx={{ display: { xs: "inline", sm: "none" } }}>
        <Grid item xs={12} lg={12} align="right">
          <Accion funcion={props.funcion} accion="alta">
            <IconButton
              title="Nuevo"
              size="medium"
              component={Link}
              to={"/alta_tramite/"}
              sx={{
                color: "#fff",
                backgroundColor: "#799F4F",
                "&:hover": { color: "#fff", backgroundColor: "#546f37" },
                margin: 1,
              }}
            >
              <AddIcon />
            </IconButton>
          </Accion>
        </Grid>
      </Grid>
      <Toolbar disableGutters>
        <Grid container spacing={1} align="left">
          <Grid item align="left">
            <Paper
              elevation={0}
              sx={{
                display: "flex",
                border: (theme) => `1px solid ${theme.palette.divider}`,
                flexWrap: "wrap",
              }}
            >

              <StyledToggleButtonGroup
                size="small"
                value={alignment}
                exclusive
                onChange={handleAlignment}
                aria-label="text accionGrupal"
              >
                <Accion funcion={props.funcion} accion="imprimir_caratula">
                  {/* <Recepcionar
                    activo={"S"}
                    mostrar="icono"
                    numSelected={numSelected}
                    datos={selected}
                    resultado={resetearTabla}
                    submitting={submitting}
                  /> */}
                  <Estados
                    activo={"S"}
                    mostrar="icono"
                    numSelected={numSelected}
                    datos={selected}
                    resultado={resetearTabla}
                    submitting={submitting}
                  />
                  <Archivar
                    activo={"S"}
                    mostrar="icono"
                    numSelected={numSelected}
                    datos={selected}
                    resultado={resetearTabla}
                    submitting={submitting}
                  />
                </Accion>
                <GeneradorPDF expedientes={expedientes} />
              </StyledToggleButtonGroup>
            </Paper>
          </Grid>
        </Grid>

        <Grid container sx={{ display: { xs: "none", sm: "block" } }}>
          <Grid item xs={12} sm={12} md={12} lg={12} align="right">
            <Accion funcion={props.funcion} accion="alta">
              <Button
                variant="verde"
                sx={{ m: 1 }}
                endIcon={<AddIcon />}
                component={Link}
                to={"/alta_tramite/"}
              >
                Nuevo
            </Button>
            </Accion>
          </Grid>
        </Grid>
      </Toolbar>
    </>
  );
};

EnhancedTableToolbar.propTypes = {
  numSelected: PropTypes.number.isRequired,
};

const ConsultaMulticriterios = (props) => {
  const [buscandoTema, setBuscandoTema] = useState(false);
  const [buscandoOrganismoGenerador, setBuscandoOrganismoGenerador] = useState(false);
  const dispatch = useDispatch();

  const leyendaTema =
    "Podés buscar directamente por código o acceder al buscador ampliado en la lupa.";

  const leyendaOrganismoGenerador =
    "Podés buscar directamente por código o acceder al buscador ampliado en la lupa.";

  const location = useLocation();
  const breadcrumbs = [
    { nombre: "Inicio", ruta: "/" },
    { nombre: "Consulta de expedientes y trámites internos", ruta: "" },
  ];
  const [datos, setDatos] = useState([]);
  const [filtros, setFiltros] = useState({
    nroExpediente: "",
    nroTramite: "",
    digital: "T",
    archivado: "T",
    tipoTramite: "T",
    codigoTema: "",
    tema: "",
    asunto: "",
    codigoOrganismoGenerador: "",
    organismoGenerador: "",
    iniciadores: 0,
    fechaDesde: "",
    fechaHasta: "",
  });
  const [submitting, setSubmitting] = useState(false);
  const [order, setOrder] = React.useState("desc");
  const [orderBy, setOrderBy] = React.useState("selectos");
  const [selected, setSelected] = useState([]);

  const [page, setPage] = React.useState(0);

  const [rowsPerPage, setRowsPerPage] = React.useState(5);

  const [lblCriterios, setLblCriterios] = useState("Criterios de búsqueda");

  const [openDocumento, setOpenDocumento] = useState(false);

  const [documento, setDocumento] = useState("");

  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === "asc";
    setOrder(isAsc ? "desc" : "asc");
    setOrderBy(property);
  };

  const handleSelectAllClick = (event) => {
    if (event.target.checked) {
      const newSelecteds = datos.map((n) => n);
      setSelected(newSelecteds);
      return;
    }
    setSelected([]);
  };

  const handleClick = (event, name) => {
    const selectedIndex = selected.indexOf(name);
    let newSelected = [];

    if (selectedIndex === -1) {
      newSelected = newSelected.concat(selected, name);
    } else if (selectedIndex === 0) {
      newSelected = newSelected.concat(selected.slice(1));
    } else if (selectedIndex === selected.length - 1) {
      newSelected = newSelected.concat(selected.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(
        selected.slice(0, selectedIndex),
        selected.slice(selectedIndex + 1)
      );
    }

    setSelected(newSelected);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const handleChangeTextField = (event) => {
    if (/^\d*$/.test(event.target.value)) {
      formik.setFieldValue(event.target.id, event.target.value);
    }
  };

  const handleChangeNroExpediente = (event) => {
    if (formik.values.nroExpediente !== "" && formik.values.nroExpediente !== null) formik.handleChange(event);
    if (/^\d*$/.test(event.target.value)) formik.setFieldValue("nroExpediente", event.target.value);
    setDatos([]);
    setLblCriterios("Criterios de búsqueda");
  };

  const handleChangeNroTramite = (event) => {
    if (formik.values.nroTramite !== "" && formik.values.nroTramite !== null) formik.handleChange(event);
    if (/^\d*$/.test(event.target.value)) formik.setFieldValue("nroTramite", event.target.value);
    setDatos([]);
    setLblCriterios("Criterios de búsqueda");
  };

  const handleChangeDigital = (event) => {
    formik.handleChange(event);
    setDatos([]);
    setLblCriterios("Criterios de búsqueda");
  };

  const handleChangeTipoTramite = (event) => {
    formik.handleChange(event);
    setDatos([]);
    setLblCriterios("Criterios de búsqueda");
  };

  const handleChangeArchivado = (event) => {
    formik.handleChange(event);
    setDatos([]);
    setLblCriterios("Criterios de búsqueda");
  };

  const handleChangeFechaDesde = (event) => {
    formik.handleChange(event);
    setDatos([]);
    setLblCriterios("Criterios de búsqueda");
  };

  const handleChangeFechaHasta = (event) => {
    formik.handleChange(event);
    setDatos([]);
    setLblCriterios("Criterios de búsqueda");
  };

  const handleChangeAsunto = (event) => {
    formik.handleChange(event);
    setDatos([]);
    setLblCriterios("Criterios de búsqueda");
  };

  const handleChangeIniciadores = (event) => {
    formik.handleChange(event);
    setDatos([]);
    setLblCriterios("Criterios de búsqueda");
  };

  const handleCloseDocument = () => {
    setOpenDocumento(false);
  };

  const verCaratula = async (tramiteId) => {
    try {
      let base64 = await api.obtenerCaratula({ tramiteId: tramiteId });
      setDocumento(base64.data);
      setOpenDocumento(true);
    } catch (e) {
      dispatch(setError("Error al obtener la carátula"));
    }
  };

  const verVolante = async (tramiteId) => {
    try {
      let base64 = await api.obtenerVolante({ tramiteId: tramiteId });
      setDocumento(base64.data);
      setOpenDocumento(true);
    } catch (e) {
      dispatch(setError("Error al obtener el volante"));
    }
  };

  const isSelected = (name) => selected.indexOf(name) !== -1;

  // Avoid a layout jump when reaching the last page with empty rows.
  const emptyRows =
    page > 0 ? Math.max(0, (1 + page) * rowsPerPage - datos.length) : 0;

  const formik = useFormik({
    initialValues: {
      nroExpediente: "",
      nroTramite: "",
      digital: "T",
      archivado: "T",
      tipoTramite: "T",
      codigoTema: "",
      tema: "",
      asunto: "",
      codigoOrganismoGenerador: "",
      organismoGenerador: "",
      iniciadores: 0,
      fechaDesde: "",
      fechaHasta: "",
    },
    lblCriterios: "Criterios de búsqueda",
    enableReinitialize: true,
    validationSchema: validationSchema,
    onSubmit: (values) => {
      setDatos([]);
      setLblCriterios("Criterios de búsqueda");
      setPage(0);
      let reqIniciadores = null;
      if (iniciadores.length > 0) {
        reqIniciadores = iniciadores.map((iniciador, index) => {
          return {
            PRS_ID: iniciador.personaId,
            ORF_ID: iniciador.organismoId,
          };
        });
      }
      formik.values.nroExpediente !== "" ||
        formik.values.nroTramite !== "" ||
        formik.values.digital !== "T" ||
        formik.values.tipoTramite !== "T" ||
        formik.values.fechaDesde !== "" ||
        formik.values.fechaHasta !== "" ||
        formik.values.asunto !== "" ||
        formik.values.archivado !== "T" ||
        formik.values.codigoOrganismoGenerador !== "" ||
        formik.values.codigoTema !== ""
        ? setLblCriterios("Criterios aplicados")
        : setLblCriterios("Criterios de búsqueda");

      let body = {
        nroExpediente: formik.values.nroExpediente,
        nroTramite: formik.values.nroTramite,
        digital: formik.values.digital,
        tipoTramite: formik.values.tipoTramite,
        fechaDesde: formik.values.fechaDesde,
        fechaHasta: formik.values.fechaHasta,
        asunto: formik.values.asunto,
        archivado: formik.values.archivado,
        codigoOrganismoGenerador: formik.values.codigoOrganismoGenerador,
        codigoTema: formik.values.codigoTema,
        iniciadores:
          reqIniciadores !== null
            ? JSON.stringify(reqIniciadores)
            : reqIniciadores,
      };
      buscarTramites(body);
    },
    onReset: () => {
      //limpiamos los objetos de selección y búsqueda.
      setSelected([]);
      setDatos([]);
      setLblCriterios("Criterios de búsqueda");
    },
  });

  const handleTema = (tema = null) => {
    if (tema !== null) {
      let soporte = tema.digital === "EN PAPEL" ? "papel" : "digital";
      formik.setFieldValue("codigoTema", tema.id);
      formik.setFieldValue("tema", tema.descTemaCompleto);
      formik.setFieldValue("soporte", soporte);
      if (soporte === "papel") {
        formik.setFieldValue("folios", 1);
      } else {
        formik.setFieldValue("folios", 0);
      }
    } else {
      formik.setFieldValue("tema", "");
      formik.setFieldValue("soporte", "");
      formik.setFieldValue("folios", 0);
    }
  };

  const handleOrganismoGenerador = (organismoGenerador = null) => {
    if (organismoGenerador !== null) {
      formik.setFieldValue("codigoOrganismoGenerador", organismoGenerador.id);
      formik.setFieldValue("organismoGenerador", organismoGenerador.descOrgCompleta);
    } else {
      formik.setFieldValue("codigoOrganismoGenerador", "");
      formik.setFieldValue("organismoGenerador", "");
    }
  };

  const handleCodigo = (event) => {
    if (event.keyCode === 13 || event.keyCode === 9) {
      if (event.target.value !== "" && event.target.value !== null) {
        buscarTemaPorCodigo(event.target.value);
      }
    } else if (
      event.type === "blur" &&
      formik.values.tema === "" &&
      event.target.value !== "" &&
      event.target.value !== null
    ) {
      buscarTemaPorCodigo(event.target.value);
    }
  };

  const buscarOrganismoGeneradorPorCodigo = (codigoOrganismoGenerador) => {
    setBuscandoOrganismoGenerador(true);
    api
      .buscarOrganismo({
        id: codigoOrganismoGenerador,
        descripcion: "",
        alta: "N",
        accion: "consulta",
      })
      .then((res) => {
        if (res.data && res.data.length > 0) {
          handleOrganismoGenerador(res.data[0]);
        } else {
          handleOrganismoGenerador();
          dispatch(setError("No se encontró el organismo"));
        }
      })
      .catch((e) => {
        handleOrganismoGenerador();
        dispatch(setError("Error al buscar el organismo"));
      })
      .finally(() => {
        setBuscandoOrganismoGenerador(false);
      })
  };


  const handleCodigoOrganismoGenerador = (event) => {
    if (event.keyCode === 13 || event.keyCode === 9) {
      if (event.target.value !== "" && event.target.value !== null) {
        buscarOrganismoGeneradorPorCodigo(event.target.value);
      }
    } else if (
      event.type === "blur" &&
      formik.values.organismoGenerador === "" &&
      event.target.value !== "" &&
      event.target.value !== null
    ) {
      buscarOrganismoGeneradorPorCodigo(event.target.value);
    }
  };

  const handleChangeCodigo = (event) => {
    if (formik.values.tema !== "" && formik.values.tema !== null) handleTema();

    if (/^\d*$/.test(event.target.value)) formik.setFieldValue("codigoTema", event.target.value);
    setDatos([]);
    setLblCriterios("Criterios de búsqueda");
  };

  const handleChangeCodigoOrganismoGenerador = (event) => {
    if (formik.values.organismoGenerador !== "" && formik.values.organismoGenerador !== null) handleOrganismoGenerador();

    if (/^\d*$/.test(event.target.value)) formik.setFieldValue("codigoOrganismoGenerador", event.target.value);
    setDatos([]);
    setLblCriterios("Criterios de búsqueda");
  };

  const buscarTemaPorCodigo = (codigo) => {
    setBuscandoTema(true);
    api
      .buscarTema({
        id: codigo,
        descripcion: "",
        general: "T",
        digital: "T",
        activo: "S",
        alta: "S",
      })
      .then((res) => {
        if (res.data && res.data.length > 0) {
          handleTema(res.data[0]);
        } else {
          handleTema();
          dispatch(setError("No se encontró tema"));
        }
      })
      .catch((e) => {
        handleTema();
        dispatch(setError("Error al buscar el tema"));
      })
      .finally(() => {
        setBuscandoTema(false);
      })
  };

  const buscarTramites = (filtros) => {
    setSubmitting(true);
    setDatos([]);
    api
      .consultaMulticriterios(filtros)
      .then((res) => {
        setDatos(res.data);
        setFiltros(res.data);
        //setSelected([]);
      })
      .catch((e) => {
        dispatch(setError(e.response.data.error));
        console.log("Error al cargar los datos");
      })
      .finally(() => setSubmitting(false));
  };

  const [expand, setExpand] = React.useState(true);
  const [expandini, setExpandIni] = React.useState(false);
  const toggleAcordion = () => {
    setExpand((prev) => !prev);
  };
  const toggleAcordionIni = () => {
    setExpandIni((prev) => !prev);
  };

  const [iniciadores, setIniciadores] = useState([]);
  const handleIniciadores = (iniciadores) => {
    setIniciadores(iniciadores);
    formik.setFieldValue("iniciadores", iniciadores.length)
  };

  const handleClickReset = () => {
    formik.handleReset();
    setIniciadores([]);
  }

  return (
    <MinimalPage breadcrumbs={breadcrumbs} disableCheckAuth>
      <Accordion sx={{ pl: 1, pr: 1 }} disableGutters expanded={expand} onChange={toggleAcordion}>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel-filtros"
          id="panel-filtros"
          sx={{ height: "50px" }}
        >
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              flexWrap: "wrap",
            }}
          >
            <FilterAltOutlinedIcon
              color={submitting ? "secondary" : "primary"}
              sx={{ mr: 1, display: { xs: "none", md: "inline" } }}
            />
            <Typography variant="cuerpo">{lblCriterios}</Typography>
          </Box>
        </AccordionSummary>
        <AccordionDetails sx={{ p: 1 }}>
          <form
            id="buscador"
            name="buscador"
            onSubmit={formik.handleSubmit}
            onReset={formik.handleReset}
            noValidate
            autoComplete="off"
          >
            <Grid container spacing={1} sx={{ pl: 2, pr: 2 }}>
              <Grid item xs={12} lg={4} sx={{ mb: 1 }}>
                <TextField
                  id="nroExpediente"
                  name="nroExpediente"
                  label="Número de expediente"
                  variant="outlined"
                  size="small"
                  fullWidth
                  value={formik.values.nroExpediente}
                  onChange={handleChangeNroExpediente}
                  onKeyDown={handleChangeTextField}
                  error={
                    formik.touched.nroExpediente &&
                    Boolean(formik.errors.nroExpediente)
                  }
                  helperText={
                    formik.touched.nroExpediente && formik.errors.nroExpediente
                  }
                  autoFocus
                />
              </Grid>
              <Grid item xs={12} lg={4} sx={{ mb: 1 }}>
                <TextField
                  id="nroTramite"
                  name="nroTramite"
                  label="Número de trámite"
                  variant="outlined"
                  size="small"
                  fullWidth
                  value={formik.values.nroTramite}
                  onChange={handleChangeTextField, handleChangeNroTramite}
                  error={
                    formik.touched.nroTramite &&
                    Boolean(formik.errors.nroTramite)
                  }
                  helperText={
                    formik.touched.nroTramite && formik.errors.nroTramite
                  }
                />
              </Grid>
              <Grid item xs={12} lg={4} sx={{ mb: 1 }}>
                <FormControl
                  variant="outlined"
                  size="small"
                  error={
                    formik.touched.digital && Boolean(formik.errors.digital)
                  }
                  fullWidth
                >
                  <InputLabel id="digitalLabel">Soporte</InputLabel>
                  <Select
                    labelId="digitalLabel"
                    id="digital"
                    name="digital"
                    variant="outlined"
                    label="Soporte"
                    value={formik.values.digital}
                    onChange={handleChangeDigital}
                  >
                    <MenuItem value="T">TODOS</MenuItem>
                    <MenuItem value="S">DIGITAL</MenuItem>
                    <MenuItem value="N">PAPEL</MenuItem>
                  </Select>
                  <FormHelperText>
                    {formik.touched.digital && formik.errors.digital}
                  </FormHelperText>
                </FormControl>
              </Grid>
            </Grid>
            <Grid container spacing={1} sx={{ pl: 2, pr: 2 }}>
              <Grid item xs={12} lg={8} sx={{ mb: 0 }}>
                <Grid container spacing={1}>
                  <Grid item xs={12} lg={6}>
                    <FormControl
                      variant="outlined"
                      size="small"
                      error={
                        formik.touched.tipoTramite && Boolean(formik.errors.tipoTramite)
                      }
                      fullWidth
                    >
                      <InputLabel id="tipoTramiteLabel">Tipo de trámite</InputLabel>
                      <Select
                        labelId="tipoTramiteLabel"
                        id="tipoTramite"
                        name="tipoTramite"
                        variant="outlined"
                        label="Tipo de trámite"
                        value={formik.values.tipoTramite}
                        onChange={handleChangeTipoTramite}
                      >
                        <MenuItem value="T" selected>
                          TODOS
                    </MenuItem>
                        <MenuItem value="expediente">EXPEDIENTE</MenuItem>
                        <MenuItem value="tramite">TRÁMITE INTERNO</MenuItem>
                      </Select>
                      <FormHelperText>
                        {formik.touched.tipoTramite && formik.errors.tipoTramite}
                      </FormHelperText>
                    </FormControl>
                  </Grid>
                  <Grid item xs={12} lg={6} sx={{ mb: 1 }}>
                    <FormControl
                      variant="outlined"
                      size="small"
                      error={
                        formik.touched.archivado && Boolean(formik.errors.archivado)
                      }
                      fullWidth
                    >
                      <InputLabel id="archivadoLabel">Archivado</InputLabel>
                      <Select
                        labelId="archivadoLabel"
                        id="archivado"
                        name="archivado"
                        variant="outlined"
                        label="Archivado"
                        value={formik.values.archivado}
                        onChange={handleChangeArchivado}
                      >
                        <MenuItem value="T">TODOS</MenuItem>
                        <MenuItem value="S">SI</MenuItem>
                        <MenuItem value="N">NO</MenuItem>
                      </Select>
                      <FormHelperText>
                        {formik.touched.archivado && formik.errors.archivado}
                      </FormHelperText>
                    </FormControl>
                  </Grid>
                </Grid>
                <Grid container spacing={1} sx={{ paddingLeft: 0 }}>
                  <Grid item xs={12} lg={2}>
                    <TextField
                      id="codigoTema"
                      name="codigoTema"
                      label="Código de tema"
                      variant="outlined"
                      size="small"
                      fullWidth
                      value={formik.values.codigoTema}
                      onChange={handleChangeCodigo}
                      onKeyDown={handleCodigo}
                      onBlur={handleCodigo}
                      error={
                        formik.touched.codigoTema && Boolean(formik.errors.codigoTema)
                      }
                      helperText={formik.touched.codigoTema && formik.errors.codigoTema}
                    />
                    <Typography
                      variant="aclaracion"
                      sx={{
                        display: {
                          xs: "inline",
                          sm: "inline",
                          md: "inline",
                          lg: "none",
                        },
                      }}
                    >
                      {leyendaTema}
                    </Typography>
                  </Grid>
                  <Grid item xs={12} lg={10}>
                    <Box display="flex" flexDirection="row">
                      <TextField
                        id="tema"
                        name="tema"
                        label="Tema"
                        variant="outlined"
                        size="small"
                        fullWidth
                        value={formik.values.tema}
                        onChange={formik.handleChange}
                        error={formik.touched.tema && Boolean(formik.errors.tema)}
                        helperText={formik.touched.tema && formik.errors.tema}
                        disabled
                      />
                      {buscandoTema ? (
                        <CircularProgress
                          color="primary"
                          size={20}
                          sx={{ margin: 1 }}
                        />
                      ) : (
                          <BuscadorTema resultado={handleTema} activo={"T"} alta={"N"} />
                        )}
                    </Box>
                  </Grid>
                </Grid>
                <Grid container spacing={1}>
                  <Grid item xs={12} lg={12} sx={{ mb: 1 }}>
                    <Typography
                      variant="aclaracion"
                      sx={{
                        display: { xs: "none", sm: "none", md: "none", lg: "inline" },
                      }}
                    >
                      {leyendaTema}
                    </Typography>
                  </Grid>
                </Grid>
              </Grid>
              <Grid item xs={12} lg={4} sx={{ mb: 0 }}>
                <Card >
                  <CardContent sx={{ padding: 1, height: "115px" }}>
                    <Typography
                      variant="cuerpo"
                    >
                      Fecha de inicio
                      </Typography>
                    <Divider />
                    {/* aquí divido en 2 celdas */}
                    <Grid container spacing={1}>
                      <Grid item xs={6} lg={6} sx={{ mb: 1 }}>
                        <FormControl
                          variant="outlined"
                          size="small"
                          sx={{ marginTop: 2 }}
                          error={
                            formik.touched.fechaDesde && Boolean(formik.errors.fechaDesde)
                          }
                          fullWidth
                        >
                          <TextField
                            id="fechaDesde"
                            type="date"
                            value={formik.values.fechaDesde}
                            label="Fecha desde"
                            variant="outlined"
                            size="small"
                            onChange={handleChangeFechaDesde}
                            InputLabelProps={{ shrink: true }} />
                          <FormHelperText>
                            {formik.touched.fechaDesde && formik.errors.fechaDesde}
                          </FormHelperText>
                        </FormControl>
                      </Grid>
                      <Grid item xs={6} lg={6} sx={{ mb: 1 }}>
                        <FormControl
                          variant="outlined"
                          size="small"
                          sx={{ marginTop: 2 }}
                          error={
                            formik.touched.fechaHasta && Boolean(formik.errors.fechaHasta)
                          }
                          fullWidth
                        >
                          <TextField
                            id="fechaHasta"
                            type="date"
                            value={formik.values.fechaHasta}
                            label="Fecha hasta"
                            variant="outlined"
                            size="small"
                            onChange={handleChangeFechaHasta}
                            InputLabelProps={{ shrink: true }} />
                          <FormHelperText>
                            {formik.touched.fechaHasta && formik.errors.fechaHasta}
                          </FormHelperText>
                        </FormControl>
                      </Grid>
                    </Grid>
                    {/* Fin de 2 celdas */}
                  </CardContent>
                </Card>
              </Grid>
            </Grid>
            <Grid container spacing={1} sx={{ pl: 2, pr: 2 }}>
              <Grid item xs={12} lg={8} sx={{ mb: 0 }}>
                <Grid container spacing={1}>
                  <Grid item xs={12} lg={2}>
                    <TextField
                      id="codigoOrganismoGenerador"
                      name="codigoOrganismoGenerador"
                      label="Código de organismo"
                      variant="outlined"
                      size="small"
                      fullWidth
                      value={formik.values.codigoOrganismoGenerador}
                      onChange={handleChangeCodigoOrganismoGenerador}
                      onKeyDown={handleCodigoOrganismoGenerador}
                      onBlur={handleCodigoOrganismoGenerador}
                      error={
                        formik.touched.codigoOrganismoGenerador && Boolean(formik.errors.codigoOrganismoGenerador)
                      }
                      helperText={formik.touched.codigoOrganismoGenerador && formik.errors.codigoOrganismoGenerador}
                    />
                    <Typography
                      variant="aclaracion"
                      sx={{
                        display: {
                          xs: "inline",
                          sm: "inline",
                          md: "inline",
                          lg: "none",
                        },
                      }}
                    >
                      {leyendaOrganismoGenerador}
                    </Typography>
                  </Grid>
                  <Grid item xs={12} lg={10}>
                    <Box display="flex" flexDirection="row">
                      <TextField
                        id="organismoGenerador"
                        name="organismoGenerador"
                        label="Organismo"
                        variant="outlined"
                        size="small"
                        fullWidth
                        value={formik.values.organismoGenerador}
                        onChange={formik.handleChangeOrganismoGenerador}
                        error={formik.touched.organismoGenerador && Boolean(formik.errors.organismoGenerador)}
                        helperText={formik.touched.organismoGenerador && formik.errors.organismoGenerador}
                        disabled
                      />
                      {buscandoOrganismoGenerador ? (
                        <CircularProgress
                          color="primary"
                          size={20}
                          sx={{ margin: 1 }}
                        />
                      ) : (
                          <BuscadorOrganismo resultado={handleOrganismoGenerador} activo={"T"} alta={"N"} accion="consulta" />
                        )}
                    </Box>
                  </Grid>
                </Grid>
                <Grid container>
                  <Grid item xs={12} lg={12} sx={{ mt: 0, mb: 1, pt: 0 }}>
                    <Typography
                      variant="aclaracion"
                      sx={{
                        display: { xs: "none", sm: "none", md: "none", lg: "inline" },
                      }}
                    >
                      {leyendaOrganismoGenerador}
                    </Typography>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
            <Grid container spacing={1} sx={{ pl: 2, pr: 2 }}>
              <Grid item xs={12} lg={12} sx={{ mb: 1 }}>
                <FormControl
                  variant="outlined"
                  size="small"
                  error={
                    formik.touched.asunto && Boolean(formik.errors.asunto)
                  }
                  fullWidth
                >
                  <TextField
                    id="asunto"
                    name="asunto"
                    label="Asunto"
                    variant="outlined"
                    size="small"
                    fullWidth
                    value={formik.values.asunto}
                    onChange={handleChangeAsunto}
                    error={formik.touched.asunto && Boolean(formik.errors.asunto)}
                    helperText={formik.touched.asunto && formik.errors.asunto}
                  />
                </FormControl>
              </Grid>
            </Grid>
            {/* <Grid container spacing={1} sx={{ pl: 2, pr: 2 }}>
              <Grid item xs={12} lg={12} sx={{ mb: 1 }}>
                <FormControl
                  variant="outlined"
                  size="small"
                  error={
                    formik.touched.iniciadores && Boolean(formik.errors.iniciadores)
                  }
                  fullWidth
                >
                  <TextField
                    id="iniciadores"
                    name="iniciadores"
                    label="Iniciadores"
                    variant="outlined"
                    size="small"
                    fullWidth
                    value={formik.values.iniciadores}
                    onChange={handleChangeIniciadores}
                    error={formik.touched.iniciadores && Boolean(formik.errors.iniciadores)}
                    helperText={formik.touched.iniciadores && formik.errors.iniciadores}
                  />
                </FormControl>
              </Grid>
            </Grid> */}
            <Grid container spacing={1} sx={{ pl: 2, pr: 2 }}>
              <Grid item xs={12} lg={12} sx={{ mb: 1 }}>
                <Accordion disableGutters expanded={expandini} onChange={toggleAcordionIni}>
                  <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls="panel-filtros-ini"
                    id="panel-filtros-ini"
                    sx={{ height: "50px" }}
                  >
                    <Box
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        flexWrap: "wrap",
                      }}
                    >
                      <SearchIcon
                        color={submitting ? "secondary" : "primary"}
                        sx={{ mr: 1, display: { xs: "none", md: "inline" } }}
                      />
                      <Typography variant="cuerpo">Iniciadores</Typography>
                    </Box>
                  </AccordionSummary>
                  <AccordionDetails sx={{ p: 1 }}>
                    <Iniciadores
                      handleIniciadores={handleIniciadores}
                      iniciadores={iniciadores}
                      completo="N"
                    ></Iniciadores>
                  </AccordionDetails>
                </Accordion>
              </Grid>
            </Grid>
            <Grid container spacing={1} sx={{ pl: 2, pr: 1, paddingLeft: 1 }}>
              <Grid item lg={12} xs={12} align="right">
                <Box sx={{ display: { xs: "none", sm: "block" } }}>
                  <Button
                    variant="plata"
                    type="button"
                    sx={{ m: 1 }}
                    endIcon={<CachedIcon />}
                    onClick={handleClickReset}
                  >
                    Limpiar
                </Button>{" "}
                  <Button
                    variant="gris"
                    type="submit"
                    disabled={submitting}
                    sx={{ m: 1 }}
                    endIcon={<SearchIcon />}
                  >
                    {submitting ? "Buscando..." : "Buscar"}
                  </Button>
                </Box>
                <Box sx={{ display: { xs: "block", sm: "none" } }}>
                  <IconButton color="primary" type="reset" title="Limpiar">
                    <CachedIcon />
                  </IconButton>{" "}
                  <IconButton
                    color="primary"
                    type="submit"
                    disabled={submitting}
                    title="Buscar"
                  >
                    <SearchIcon />
                  </IconButton>
                </Box>
              </Grid>
            </Grid>
          </form>
        </AccordionDetails>
      </Accordion>
      <br></br>
      <Card>
        <CardContent>
          <Typography variant="aclaracion" gutterBottom>
            {selected.length === 1
              ? " (" + selected.length + " seleccionado)"
              : " (" + selected.length + " seleccionados)"}
          </Typography>
          <EnhancedTableToolbar numSelected={selected.length} selected={selected} resetearTabla={() => buscarTramites(formik.values)} funcion={props.funcion} submitting={submitting} expedientes={datos}/>
          <TableContainer>
            <Table
              sx={{ minWidth: 750, border: "1px solid #dee2e6" }}
              aria-labelledby="tableTitle"
              size="small"
            >
              <EnhancedTableHead
                numSelected={selected.length}
                order={order}
                orderBy={orderBy}
                onSelectAllClick={handleSelectAllClick}
                onRequestSort={handleRequestSort}
                rowCount={datos.length}
              />
              <TableBody>
                {/* if you don't need to support IE11, you can replace the `stableSort` call with:
                 rows.slice().sort(getComparator(order, orderBy)) */}
                {stableSort(datos, getComparator(order, orderBy))
                  .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                  .map((dato, index) => {

                    const isItemSelected = isSelected(dato);
                    const labelId = `enhanced-table-checkbox-${index}`;

                    return (
                      <TableRow
                        hover
                        role="checkbox"
                        aria-checked={isItemSelected}
                        tabIndex={-1}
                        key={dato.id}
                        selected={isItemSelected}
                        sx={
                          index % 2 === 0
                            ? { backgroundColor: "#f2f2f2" }
                            : { backgroundColor: "#fff" }
                        }
                      >
                        <TableCell padding="checkbox">
                          <Checkbox
                            color="primary"
                            checked={selected.find((selected) => selected.id === dato.id)} //chequeamos que si se encuentra en el objeto de selección, los tílde o marque.
                            //checked={isItemSelected}
                            id="selectos"
                            name="selectos"
                            inputProps={{
                              "aria-labelledby": labelId,
                            }}
                            onClick={(event) => handleClick(event, dato)}
                          />
                        </TableCell>
                        <TableCell
                          component="th"
                          id={labelId}
                          scope="row"
                          padding="none"
                        >
                          {dato.expedienteConFecha}
                        </TableCell>
                        <TableCell align="left">
                          {dato.fechaTramiteInterno !== "" && dato.fechaExpediente !== "" && dato.fechaTramiteInterno !== dato.fechaExpediente ? dato.tramiteInternoConFecha : null}
                        </TableCell>
                        <TableCell align="left">
                          {dato.descOrgGenCompleta}
                        </TableCell>
                        <TableCell align="left">{dato.asunto}</TableCell>
                        <TableCell align="left">{dato.soporte}</TableCell>
                        <TableCell align="center">
                          <IconButton
                            title="Gestionar"
                            size="small"
                            component={Link}
                            to={{
                              pathname: "/ver_tramite/" + dato.id,
                              state: { from: location },
                            }}
                          >
                            <AppRegistrationOutlinedIcon fontSize="small" />
                          </IconButton>
                          <Accion funcion={props.funcion} accion="imprimir_caratula">
                            <IconButton
                              title="Imprimir carátula"
                              fontize="small"
                              onClick={() => { verCaratula(dato.id); handleCloseDocument(); }}
                              disabled={dato.soporte === "PAPEL" && dato.muestra_caratula === "S" ? false : true}
                            >
                              <PrintOutlinedIcon fontSize="small" />
                            </IconButton>
                          </Accion>
                          <Accion funcion={props.funcion} accion="Volante">
                            <IconButton
                              title="Ver volante"
                              onClick={() => verVolante(dato.id)}
                              size="small"
                            >
                              <FileDownloadOutlinedIcon fontSize="small" />
                            </IconButton>
                          </Accion>
                        </TableCell>
                      </TableRow>
                    );
                  })}
                {submitting ? (
                  <TableRow>
                    <TableCell colSpan="7" align="center">
                      <CircularProgress />
                    </TableCell>
                  </TableRow>
                ) : (
                    null
                  )}
                {datos.length === 0 && !submitting ? (
                  <TableRow>
                    <TableCell colSpan="7" align="center">
                      <Typography variant="aclaracion">No hay datos para mostrar</Typography>
                    </TableCell>
                  </TableRow>
                ) : (
                    null
                  )}
                {emptyRows > 0 && (
                  <TableRow
                    style={{
                      height: 53 * emptyRows,
                    }}
                  >
                    <TableCell colSpan={7} />
                  </TableRow>
                )}
              </TableBody>
              <TableFooter>
                <TableRow>
                  <TablePagination
                    rowsPerPageOptions={[
                      5,
                      10,
                      25,
                      { label: "Todos", value: datos.length },
                    ]}
                    count={datos.length}
                    rowsPerPage={rowsPerPage}
                    page={page}
                    onPageChange={handleChangePage}
                    onRowsPerPageChange={handleChangeRowsPerPage}
                    selected={selected}
                    ActionsComponent={TablePaginationActions}
                  />
                </TableRow>
              </TableFooter>
            </Table>
          </TableContainer>
          <Typography variant="aclaracion" gutterBottom>
            {selected.length === 1
              ? " (" + selected.length + " seleccionado)"
              : " (" + selected.length + " seleccionados)"}
          </Typography>
        </CardContent>
      </Card>

      <Modal open={openDocumento} handleClose={handleCloseDocument} closeButton>
        <VisorPdf url={"data:application/octet-stream;base64," + documento} />
      </Modal>

    </MinimalPage >
  );
};

export default ConsultaMulticriterios;